<template>
  <el-dialog
    title="查看称重信息"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      ref="form"
      label-position="right"
      label-width="100px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="车辆编号">
            <div class="text" :title="form.CarId">
              {{ form.CarId | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入场编号">
            <div class="text" :title="form.RegistrationNum">
              {{ form.RegistrationNum | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车牌号">
            <div class="text" :title="form.LicensePlate">
              {{ form.LicensePlate | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="VIN后六位">
            <div class="text" :title="form.VinSix">
              {{ form.VinSix | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车主姓名">
            <div class="text" :title="form.OwnerName">
              {{ form.OwnerName | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="司磅员" prop="Unit">
            <div class="text" :title="form.WeighUserId">
              {{ form.WeighUserId | UserNameInfo }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="毛重" prop="GrossWeight">
            <div class="text" :title="form.Quantity">
              {{ form.GrossWeight }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="毛重时间">
            <div class="text" :title="form.GrossDate">
              {{ form.GrossDate | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="皮重">
            <div class="text" :title="form.TareWeight">
              {{ form.TareWeight }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="皮重时间">
            <div class="text" :title="form.TareDate">
              {{ form.TareDate | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="净重">
            <div class="text" :title="form.CarWeigh">
              {{ form.CarWeigh }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="净重时间">
            <div class="text" :title="form.WeighDate">
              {{ form.WeighDate | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收车员">
            <div class="text" :title="form.CreateUserId">
              {{ form.CreateUserId | UserNameInfo }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收车时间">
            <div class="text" :title="form.RegDate">
              {{ form.CreateTime | gang }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="整车照">
            <div>
              <el-image
                style="width: 130px; height: 130px"
                :src="form.VehiclePhotoUrl"
                :preview-src-list="[form.VehiclePhotoUrl]"
              >
              </el-image>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
    
<script>
export default {
  props: ["item"],
  data() {
    return {
      visible: false,
      form: {},
    };
  },
  watch: {
    item: {
      handler: function (v) {
        this.visible = true;
        this.$get("CarWeight/GetItem", {
          KeyId: v.KeyId,
        }).then((r) => {
          this.form = { ...r.Result };
        });
      },
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
</style>